import { render } from "./MiniBoard.vue?vue&type=template&id=4a5346d4"
import script from "./MiniBoard.vue?vue&type=script&lang=js"
export * from "./MiniBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__